/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//ran this thru claudes code refactoring tool


// redesign this component to look more elegant and polished and accents
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
// give me the entire code to copy





//refactored before redeisgn
import React, { useEffect, useState, lazy, useCallback, useMemo, Suspense } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { FaRegTrashAlt, FaRegHeart } from "react-icons/fa";
import { FaTrashCan } from "react-icons/fa6";
import { IoMdTrash } from "react-icons/io";
import { FaEye } from "react-icons/fa";
import { RiShoppingCartLine } from "react-icons/ri";
import { TbArrowBigRightLinesFilled } from "react-icons/tb";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";

import {
    get_wishlist_products,
    remove_from_wishlist,
    move_from_wishlist_to_cart,
    messageClear
} from '../../store/reducers/cartReducer';

import ShopProductGridListView from '../products/ShopProductGridListView';
import useWindowSize from '../../utils/useWindowSize';
import SkeletonWithImage from '../SkeletonWithImage';
import GetSellerConfig from '../GetSellerConfig';

import toast from 'react-hot-toast';
import { currencyFormat } from '../CurrencyFormat';

const Rating = lazy(() => import('../Rating'));

// ─── Sub-components ──────────────────────────────────────────────────────────

const WishlistHeader = ({ count, productPluralTerm, onClearAll, primaryColor, secondaryColor, 
    sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight }) => (
    <>
        {/* Mobile header */}
        <div className='sm:block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden'>
            {count > 0 && (
                <div className='hidden text-xl font-semibold text-center'>
                    <button
                        onClick={onClearAll}
                        aria-label="Clear all wishlist items"
                        className='flex bg-red-500 m-1 text-white rounded-md px-3 py-1'>
                        <FaRegHeart className='mt-1 mr-1' /> Clear My Wishlist
                    </button>
                </div>
            )}
        </div>

        {/* Desktop header sm:hidden animate-bounce */}
        <div className='grid grid-cols-2 md-lg:grid-cols-2 md:grid-cols-1'>
            <div className="flex items-center gap-1 mb-1 pb-1">
                <div>
                    <FaRegHeart className={` ${count > 0 ? 'text-[52px]' : 'text-[26px]'} `}
                        style={{ color: primaryColor + sellerColorSuffixDark }} />
                </div>
                <div>
                    <div
                        className="text-2xl font-bold tracking-tight leading-none"
                        style={{ color: primaryColor + sellerColorSuffixDark }}>
                        My Wishlist
                    </div>
                    {count > 0 && (
                        <div className="text-md sm:text-xs xs:text-xs mt-0.5" 
                            style={{ color: primaryColor + sellerColorSuffixMedium }}>
                            {count} {productPluralTerm} That I Would Like To Consider
                        </div>
                    )}
                </div>
            </div>
            {count > 0 && (
                <div className='text-xl font-semibold'>
                    <button
                        onClick={onClearAll}
                        aria-label="Clear all wishlist items"
                        className='bg-red-500 gap-1 m-1 text-white rounded-md px-3 py-1 flex ml-auto md:ml-0'>
                        <FaRegHeart size={24} className='mt-0.5 mr-0.5' /> Clear My Wishlist
                    </button>
                </div>
            )}
        </div>
    </>
);

const EmptyWishlist = ({ primaryColor, productPluralTerm }) => (
    <div className='flex flex-col items-center justify-center py-16 gap-4'>
        <div className='flex gap-4'>
            <MdOutlineRestaurantMenu size={48} style={{ color: primaryColor, opacity: 0.3 }} />
            <FaRegHeart size={48} style={{ color: primaryColor, opacity: 0.3 }} />
        </div>
        <p className='text-lg font-semibold' style={{ color: primaryColor, opacity: 0.6 }}>
            My Wishlist Is Empty
        </p>
        <div className='grid grid-cols-2 sm:grid-cols-1 gap-4'>
            <Link
                to='/'
                className='px-4 py-2 rounded-md text-white text-sm'
                style={{ backgroundColor: primaryColor }}>
                Back To Home Page
            </Link>
            <Link
                to='/shops'
                className='px-4 py-2 rounded-md text-white text-sm'
                style={{ backgroundColor: primaryColor }}>
                Browse {productPluralTerm}
            </Link>
        </div>
    </div>
);

const ActionButton = ({ onClick, label, tooltip, tooltipStyle, children, as: Tag = 'button' }) => (
    <Tag
        onClick={onClick}
        aria-label={label}
        className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
        style={{ backgroundColor: 'white', ...tooltipStyle }}>
        <div className="icon-container">
            <span className='icon flex justify-center items-center'>
                &nbsp;{children}&nbsp;
            </span>
            <div className='tooltip' style={tooltipStyle}>{tooltip}</div>
        </div>
    </Tag>
);

const WishlistCard = ({product: p, config, tooltipStyle, screenWidth, onMoveToCart, onRemove, onChat, }) => {
    const { primaryColor, secondaryColor, showPayments, showRating, showChat, shoppingTerm } = config;

    const truncatedName = p.name?.substring(0, Math.floor(screenWidth / 66)) ?? '';
    const isNameTruncated = truncatedName.length < (p.name?.length ?? 0);

    const descPreviewMobile = p.description?.substring(0, Math.floor(screenWidth / 10));
    const descPreviewDesktop = p.description?.substring(0, Math.floor(screenWidth / 50));

    return (
        <div
            className='border-2 group transition-all duration-500 hover:shadow-md hover:-mt-3'
            style={{ 
                backgroundColor: secondaryColor, 
                color: primaryColor, 
                borderColor: primaryColor 
            }}>
            {/* Image + hover actions */}
            <div className='relative overflow-hidden'>
                <div className="relative text-center">
                    {/* <img className='hidden w-full h-[200px] object-cover' src={p.image} alt={p.name} />  */}
                    <SkeletonWithImage
                        className='w-full h-[200px] object-cover'
                        src={p.image}
                        alt={p.name}
                    />
                    {p.byThePan && p.byThePan !== 'NoPan' && (
                        <div
                            className='m-1 border w-[97%] h-[30px] absolute top-0 left-0 text-center'
                            style={{ 
                                backgroundColor: secondaryColor, 
                                color: primaryColor, 
                                borderColor: primaryColor 
                            }}>
                            {p.byThePan}
                        </div>
                    )}
                </div>

                <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3'>
                    <li>
                        <button
                            onClick={() => onMoveToCart(p._id)}
                            aria-label={`Move ${p.name} to ${shoppingTerm}`}
                            className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
                            style={{ backgroundColor: 'white', color: primaryColor, borderColor: primaryColor 
                            }}>
                            <div className="icon-container">
                                <span className='icon flex justify-center items-center'>
                                    &nbsp;<TbArrowBigRightLinesFilled size={12} /><MdOutlineRestaurantMenu size={20} />&nbsp;
                                </span>
                                <div className='tooltip' style={tooltipStyle}>Move To<br />{shoppingTerm}</div>
                            </div>
                        </button>
                    </li>

                    <li>
                        <button
                            onClick={() => onRemove(p._id)}
                            aria-label={`Remove ${p.name} from wishlist`}
                            className='w-[38px] h-[38px] cursor-pointer border flex bg-white justify-center items-center rounded-full transition-all'
                            style={{ backgroundColor: 'white', color: primaryColor, borderColor: primaryColor }}>
                            <div className="icon-container">
                                <span className='icon flex justify-center items-center'>
                                    &nbsp;<FaTrashCan />&nbsp;
                                </span>
                                <div className='tooltip' style={tooltipStyle}>Remove<br />From<br />Wishlist</div>
                            </div>
                        </button>
                    </li>

                    <li>
                        <Link
                            to={`/product/details/${p.productId}`}
                            aria-label={`View details for ${p.name}`}
                            className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
                            style={{ 
                                backgroundColor: 'white', 
                                color: primaryColor, 
                                borderColor: primaryColor 
                            }}>
                            <div className="icon-container">
                                <span className='icon flex justify-center items-center'>
                                    &nbsp;<FaEye size={22} />&nbsp;
                                </span>
                                <div className="tooltip" style={tooltipStyle}>More<br />Details</div>
                            </div>
                        </Link>
                    </li>

                    {showChat && (
                        <li>
                            <button
                                onClick={() => onChat(p.name)}
                                aria-label={`Chat about ${p.name}`}
                                className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
                                style={{ 
                                    backgroundColor: 'white', 
                                    color: primaryColor, 
                                    borderColor: primaryColor 
                                }}>
                                <div className="icon-container">
                                    <span className='icon flex justify-center items-center'>
                                        &nbsp;<IoChatbubbleEllipsesSharp size={18} />&nbsp;
                                    </span>
                                    <div className="tooltip" style={tooltipStyle}>Chat<br />With Us</div>
                                </div>
                            </button>
                        </li>
                    )}
                </ul>
            </div>

            {/* Product info */}
            <div className='py-3 px-2'>
                {/* Name - mobile */}
                <div className='sm:block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden'>
                    <span className='font-bold'>{p.name}</span>
                </div>
                {/* Name - desktop (truncated) */}
                <div className='sm:hidden'>
                    <span className='font-bold'>{truncatedName}</span>
                    {isNameTruncated && <span> ...</span>}
                </div>

                <div className='flex justify-start items-center gap-3'>
                    {showPayments && (
                        <span className='text-md font-semibold'>
                            {currencyFormat.format(p.price)}
                        </span>
                    )}
                    {showRating && (
                        <Suspense fallback={null}>
                            <Rating ratings={p.rating} />
                        </Suspense>
                    )}
                </div>
            </div>

            {/* Description */}
            <div className='ml-1 mr-1'>
                <div
                    className='border px-1 py-1 mb-1 w-full text-[14px] font-semibold'
                    style={{ 
                        borderColor: primaryColor, 
                        color: primaryColor, 
                        backgroundColor: secondaryColor 
                    }}>
                    <span className='sm:block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden'>
                        {descPreviewMobile} ...
                    </span>
                    <span className='sm:hidden'>
                        {descPreviewDesktop} ...
                    </span>
                </div>
            </div>

            {/* Move to cart CTA */}
            <div className='ml-1 mr-1'>
                <button
                    onClick={() => onMoveToCart(p._id)}
                    aria-label={`Move ${p.name} to ${shoppingTerm}`}
                    className='px-1 py-1 mb-1 h-[34px] w-full rounded-lg text-md cursor-pointer hover:shadow-lg text-white flex justify-center items-center'
                    style={{ backgroundColor: primaryColor }}
                >
                    <TbArrowBigRightLinesFilled className='mr-1' /> Move To My {shoppingTerm}
                </button>
            </div>
        </div>
    );
};

// ─── Main Component ───────────────────────────────────────────────────────────

const Wishlist = () => {
    const { seller } = useSelector(state => state.seller);
    const { userInfo } = useSelector(state => state.auth);
    const { wishlist, wishlist_count, errorMessage, successMessage } = useSelector(state => state.cart);
    const { screenWidth } = useWindowSize();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Derive seller config once, only when seller changes
    const sellerConfig = useMemo(() => ({
        id: seller._id,
        primaryColor:  seller.frontEndPrimaryColor1,
        secondaryColor: seller.frontEndSecondaryColor1,
        productPluralTerm: seller.productPluralTerm,
        shoppingTerm: seller.shoppingTerm,
        showPayments: seller.isVisibleSitePayments === 'Show',
        showRating: seller.isVisibleSiteRating === 'Show',
        showChat: seller.isVisibleSiteChat === 'Show',
    }), [seller]);

    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
    // sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
    // sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm,
     sellerProductPluralTerm,
    // sellerCompanyPhoneNumber, sellerCompanyLogo,sellerSellerImage, sellerBeforeYouRegister1, sellerPhoneNumber, sellerShoppingTerm, 
    // sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
    // sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
    // sellerPersonalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames,
    // sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia,
    // sellerBoolShowSiteSamplesMenus, sellerBoolShowSitePackages, sellerBoolShowCustomerTestimonials, 
    // sellerBoolShowSitePayments, sellerBoolShowSiteRating, sellerBoolShowCuisineType,
    // sellerBoolShowCookingMethods, sellerBoolShowHoliday
    } = GetSellerConfig();

    const tooltipHoverStyle = useMemo(() => ({
        color: 'white',
        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark,
    }), [sellerPrimaryColor1 + sellerColorSuffixDark]);

    // ── Handlers ─────────────────────────────────────────────────────────────

    const redirectToChat = useCallback((chatTopic) => {
        if (userInfo) {
            navigate(`/customerDashboard/chat/${chatTopic}`);
        } else {
            navigate('/login');
        }
    }, [userInfo, navigate]);

    const handleClearAll = useCallback(() => {
        if (!userInfo) return navigate('/login');
        wishlist.forEach(p => dispatch(remove_from_wishlist(p._id)));
    }, [userInfo, wishlist, dispatch, navigate]);

    const handleMoveToCart = useCallback((id) => {
        if (!userInfo) return navigate('/login');
        dispatch(move_from_wishlist_to_cart(id));
    }, [userInfo, dispatch, navigate]);

    const handleRemove = useCallback((id) => {
        dispatch(remove_from_wishlist(id));
    }, [dispatch]);

    // ── Effects ───────────────────────────────────────────────────────────────

    useEffect(() => {
        if (userInfo?.id) {
            dispatch(get_wishlist_products(userInfo.id));
        }
    }, [userInfo?.id, dispatch]);

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
        }
        if (errorMessage) {
            toast.error(errorMessage);
            dispatch(messageClear());
        }
    }, [successMessage, errorMessage, dispatch]);

    // ── Render ────────────────────────────────────────────────────────────────

    return (
        <div className='bg-white rounded-2xl'>
            <div
                className='p-4 rounded-2xl border'
                style={{
                    borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                    color: sellerPrimaryColor1 + sellerColorSuffixDark,
                    backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                }}>

                
                {/* Page title */}
                
                <WishlistHeader
                    count={wishlist_count}
                    productPluralTerm={sellerConfig.productPluralTerm}
                    onClearAll={handleClearAll}
                    primaryColor={sellerPrimaryColor1}
                    secondaryColor={sellerSecondaryColor1}
                    sellerColorSuffixDark={sellerColorSuffixDark}
                    sellerColorSuffixMedium={sellerColorSuffixMedium}
                    sellerColorSuffixLight={sellerColorSuffixLight}
                />

                {wishlist_count === 0 ? (
                    <EmptyWishlist
                        primaryColor={sellerPrimaryColor1}
                        productPluralTerm={sellerConfig.productPluralTerm}
                    />
                ) : (   
                    <div className='w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-2 mt-3'>
                        {wishlist.map(p => (
                            <WishlistCard
                                key={p._id}
                                product={p}
                                config={sellerConfig}
                                tooltipStyle={tooltipHoverStyle}
                                screenWidth={screenWidth}
                                onMoveToCart={handleMoveToCart}
                                onRemove={handleRemove}
                                onChat={redirectToChat}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Wishlist;







// import React, { useEffect, useState, lazy }  from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch,useSelector } from 'react-redux';

// import { FaEye, FaRegTrashAlt, FaHeart, FaRegHeart} from "react-icons/fa";

// import { RiShoppingCartLine } from "react-icons/ri";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { TbArrowBigRightLinesFilled } from "react-icons/tb";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// //import Rating from '../Rating';

// import { get_wishlist_products, remove_from_wishlist, move_from_wishlist_to_cart, add_to_cart, 
//     messageClear } from '../../store/reducers/cartReducer';

// import useWindowSize from '../../utils/useWindowSize';
// import toast from 'react-hot-toast';

// import { currencyFormat } from '../CurrencyFormat';
// const Rating = lazy(()=> import('../Rating')) 

// const Wishlist = () => {
//     const { seller } = useSelector(state => state.seller)
//     const { userInfo } = useSelector(state => state.auth)
//     const { wishlist, wishlist_count, errorMessage, successMessage } = useSelector(state => state.cart)
//     //console.log(wishlist)
//     const { screenWidth, screenHeight } = useWindowSize();
    
//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
//     const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
//     const sellerProductPluralTerm = seller.productPluralTerm
//     const sellerShoppingTerm = seller.shoppingTerm

//     const sellerBoolShowSitePayments = seller.isVisibleSitePayments === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteChat = seller.isVisibleSiteChat === 'Show' ? true : false
    
//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1
//     };

//     const [modalProduct, setModalProduct] = useState(null);
//     const openModal = (product) => {
//         setModalProduct(product);
//     };
//     const closeModal = () => {
//         setModalProduct(null);
//     };

//     const [portionSize, setPortionSize] = useState('')
    
//     const dispatch = useDispatch()
//     const navigate = useNavigate()
    
//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`)
//         } else {
//             navigate('/login')
//         }
//     }

//     const delete_all_wishlist_products_local = () => {
//         if (userInfo) {
//             wishlist.map((p, i) => {
//                 //console.log('p._id ', p)
//                 dispatch(remove_from_wishlist(p._id))
//             })
//         } else {
//             navigate('/login')
//         }    
//     }

//     const move_from_wishlist_to_cart_local = (id) => {
//         if (userInfo) {
//             dispatch(move_from_wishlist_to_cart(id))
//             //console.log('productId ', id)
//             //console.log('userId ', userInfo.id)
//             // dispatch(add_to_cart({
//             //     userId: userInfo.id,
//             //     quantity : 1,
//             //     productId : id, // product._id,
//             //     portionSize: portionSize
//             // }))
//             // setPortionSize('')
//         } else {
//             navigate('/login')
//         }
//     }

//     useEffect(() => {
//        dispatch(get_wishlist_products(userInfo.id))
//     },[])

//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             dispatch(messageClear())  
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])
//     //console.log('wishlist ', wishlist)
   
//     return (
//         <div className='p-4 rounded-md border'
//             style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//             <div className='text-2xl font-bold flex mb-1' style={{color:sellerPrimaryColor1}}>
//                 <FaRegHeart className='mt-1 mr-1' />My Wishlist
//             </div>
//             <div className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                 <div className='w-full text-center font-semibold mb-2 p-1 text-lg border'
//                     style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                    {wishlist_count} {sellerProductPluralTerm} That I Would Like To Consider 
//                 </div>
//                 <div className={`  ${wishlist_count > 0 ? '' : 'hidden'} text-xl font-semibold text-center items-center justify-center justify-items-center
//                     border-none border-gray-700`}>
//                     <button onClick={delete_all_wishlist_products_local} 
//                         className='flex bg-red-500 m-1 text-white rounded-md px-3 py-1'>
//                         <FaRegHeart className='mt-1 mr-1' /> Clear My Wishlist
//                     </button>
//                 </div>
//             </div>
//             <div className='grid grid-cols-2 md-lg:grid-cols-2 md:grid-cols-1 sm:hidden border-none border-gray-700'>
//                 <span className='border font-semibold mb-9 text-lg' style={{color:sellerPrimaryColor1}}>
//                     {wishlist_count} {sellerProductPluralTerm} That I Would Like To Consider
//                 </span>
//                 <div className={` ${wishlist_count > 0 ? '' : 'hidden'} 
//                     text-xl font-semibold text-right border-none border-gray-700 items-end justify-end justify-items-end `}>
//                     <button onClick={delete_all_wishlist_products_local} 
//                         className='bg-red-500 m-1 text-white rounded-md px-3 py-1 flex'>
//                         <FaRegHeart className='mt-1 mr-1' /> Clear My Wishlist
//                     </button>
//                 </div>
//             </div>
            
//             <div className='w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-2 mt-3'>
//                 {
//                     wishlist.map((p, i) => 
//                         <div key={i} className='border-2 group transition-all duration-500 hover:shadow-md hover:-mt-3'
//                             style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                             <div className='relative overflow-hidden'>
//                                 <div className="relative text-center">
//                                     <img className={`sm:w-full w-full h-[200px]`} src={p.image}  alt="" />  
//                                     <div className={` ${p.byThePan === 'NoPan' ? 'hidden' : ''}  
//                                         m-1 border w-[97%] h-[30px] absolute top-0 left-0 text-center`}
//                                         style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         {p.byThePan}
//                                     </div>
//                                 </div>
//                                 {
//                                     // p.discount !== 0 && 
//                                     // <div className='flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full 
//                                     //     bg-red-500 font-semibold text-xs left-2 top-2'>{p.discount}%
//                                     // </div> 
//                                     //<img className={`sm:w-full w-full h-[200px]`} src={p.image}  alt="" />  
//                                 }
//                                 {/* hover:bg-[#059473] hover:text-white hover:rotate-[720deg]  */}
//                                 <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3'>
//                                     <span onClick={() => move_from_wishlist_to_cart_local(p._id)} 
//                                         className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
//                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div className="icon-container">
//                                             <span className='icon flex justify-center items-center'>
//                                                 &nbsp;<TbArrowBigRightLinesFilled /> <MdOutlineRestaurantMenu />&nbsp;
//                                             </span>
//                                             <div className='tooltip' style={tooltipHoverStyle}>Move To<br />{sellerShoppingTerm}</div>
//                                         </div>
//                                     </span>
//                                     <li onClick={() => dispatch(remove_from_wishlist(p._id))} 
//                                         className='w-[38px] h-[38px] cursor-pointer border flex bg-white justify-center items-center rounded-full transition-all'
//                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div className="icon-container">
//                                             <span className='icon flex justify-center items-center'>
//                                                 &nbsp;<FaRegTrashAlt />&nbsp;
//                                             </span>
//                                             <div className='tooltipSmall' style={tooltipHoverStyle}>Remove<br />From<br />Wishlist</div>
//                                         </div>
//                                     </li>
//                                     <li>
//                                         {/* onClick={() => openModal(p)} */}
//                                         {/*  to={`/product/details/${p.productId}` */}
//                                         {/*  get product obeject fromm productid */ }
//                                         <Link to={`/product/details/${p.productId}`}
//                                             className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
//                                             style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                             <div className="icon-container">
//                                                 <span className='icon flex justify-center items-center'>
//                                                     &nbsp;<FaEye />&nbsp;
//                                                 </span>
//                                                 <div className="tooltip" style={tooltipHoverStyle}>More<br />Details</div>
//                                             </div>
//                                         </Link>
//                                     </li>
//                                     {/*onClick={redirect_chat_page}*/}
//                                      <span onClick={() => redirect_chat_page(p.name)} 
//                                         className={` ${sellerBoolShowSiteChat ? '' : 'hidden'}  
//                                         w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all`}
//                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                         <div className="icon-container">
//                                             <span className='icon flex justify-center items-center'>
//                                                 &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                                             </span>
//                                             <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                                         </div>
//                                     </span>
//                                 </ul>
//                             </div>
//                             <div className='py-3 px-2'>
//                                 {
                                    
//                                     //     <div className='sm:hidden'>
//                                     //         <span className='font-bold'>{p.name?.substring(0, parseInt(screenWidth / 42))}</span>
//                                     //         <span className={` ${(p.name?.substring(0, parseInt(screenWidth / 42))?.length >= p.name?.length) ? 'hidden' : '' } `}> ...</span>
//                                     //     </div>
//                                 }
//                                 <div className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                     <span className='font-bold'>{p.name}</span>
//                                 </div>

//                                 <div className='sm:hidden'>
//                                     <span className='font-bold'>{p.name?.substring(0, parseInt(screenWidth / 66))}</span>
//                                     <span className={` ${(p.name?.substring(0, parseInt(screenWidth / 66))?.length >= p.name?.length) ? 'hidden' : '' } `}> ...</span>
//                                 </div>
                                
//                                 <div className='flex justify-start items-center gap-3'>
//                                     <span className={`${sellerBoolShowSitePayments ? '' : 'hidden'} text-md font-semibold`}>
//                                         {currencyFormat.format(p.price)}
//                                     </span>
//                                     <div className={`${sellerBoolShowSiteRating ? 'flex' : 'hidden'} `}>
//                                         <Rating ratings={p.rating} />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className='ml-1 mr-1' >
                                
//                                 <div className={`${p.portionSizes !== '' ? 'w-full hidden' : 'hidden'} `}>
//                                     <select onChange={(e) => setPortionSize(e.target.value)} id='' name='' 
//                                         className='border rounded-md px-3 py-1 mb-1 w-full text-[14px] font-semibold' 
//                                         style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                         <option value=''>Choose Portion Size</option>
//                                         {
//                                             p.portionSizes.split(';').map((p,i) => {
//                                                 return( <option key={i} value={p}>{p}</option> )
//                                             })
//                                         }            
//                                     </select>
//                                 </div>
//                                 <div className={`${p.portionSizes === '' ? '' : ''} 
//                                     border px-1 py-1 mb-1 w-full text-[14px] font-semibold`}
//                                     style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                     <span className='sm:inline-block md-lg:hidden md:hidden lg:hidden xl:hidden 2xl:hidden 3xl:hidden 4xl:hidden 4k:hidden'>
//                                         {p.description?.substring(0, parseInt(screenWidth / 10))} ...
//                                     </span>
//                                     <span className='sm:hidden'>
//                                         {p.description?.substring(0, parseInt(screenWidth / 50))} ...
//                                     </span>
//                                 </div>
//                             </div>  
//                             <div className='ml-1 mr-1' >
//                                 <button onClick={() => move_from_wishlist_to_cart_local(p._id)} 
//                                     className={`px-1 py-1 mb-1 h-[34px] w-full rounded-lg text-md cursor-pointer
//                                     hover:shadow-lg hover:shadow-green-500/40] text-white flex justify-center items-center `} 
//                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                     <TbArrowBigRightLinesFilled className='mr-1' /> Move To My Menu
//                                 </button> 
//                             </div>
//                         </div>
//                     )
//                 }
//             </div>   
//         </div>
//     );
// };

// export default Wishlist;



